export type AlertConditionTemplate = {
  name: string
  description: string
}

export const ALERT_CONDITION_TEMPLATES: AlertConditionTemplate[] = [
  {
    name: 'Tailgating',
    description:
      'At an access-controlled door, turnstile, or barrier, a person follows closely behind another and passes through on a single badge scan or door opening without presenting their own credential. A person scanning their own badge before entering is NORMAL. Describe the people involved, the entry point, and how the second person gained access.'
  },
  {
    name: 'Slip and Fall',
    description:
      'A person slipping, tripping, or collapsing to the ground involuntarily, suggesting an accident or medical event. A person deliberately sitting, crouching, or bending down is NORMAL. Describe the person, the location, whether they get back up, and whether anyone nearby reacts.'
  },
  {
    name: 'PPE Violation',
    description:
      'A worker clearly visible in a hazard area who is not wearing required protective equipment such as a hard hat or high-visibility vest. Only flag when the relevant body part is clearly visible; do not flag when the view is obscured or too distant to assess. Describe the person, which item is missing, and their location.'
  },
  {
    name: 'Abandoned Object',
    description:
      'A bag, box, or item left on the ground or a surface with no person attending it, or where someone set it down and walked away. An item held or resting directly beside a stationary person is NORMAL. Describe the object, its location, how long it appears unattended, and the last person seen with it.'
  },
  {
    name: 'Long Queue',
    description:
      'A line of people forming at a checkout, counter, or service point that exceeds normal length, indicating a wait-time issue. A few people briefly waiting in turn is NORMAL. Describe the number of people in the queue, its location, and roughly how far it extends.'
  },
  {
    name: 'Restricted Parking',
    description:
      'A vehicle stopped or parked in a fire lane, loading bay, disabled space, or any marked no-parking area. A vehicle driving through or parked in a normal bay is NOT a violation. Describe the vehicle type, its color, and exactly where it stopped.'
  },
  {
    name: 'Intrusion',
    description:
      'A person climbing over, crawling under, or crossing a fence, wall, or boundary into a restricted area, or present in a zone during closed hours. A person using a designated gate or entrance during open hours is NORMAL. Describe the person, their point of entry, and their direction of movement.'
  },
  {
    name: 'Smoking',
    description:
      'A person holding, lighting, or smoking a cigarette, cigar, or vape in a designated no-smoking area. Look for a lit object at the mouth or visible smoke or vapor. Describe the person, their location, and what they are smoking.'
  },
  {
    name: 'Overcrowding',
    description:
      'A number of people gathering in one area that exceeds safe or expected occupancy, indicating congestion or a crowd-safety risk. A normal spread of people moving through a space is NORMAL. Describe the approximate number of people, the location, and how tightly packed they appear.'
  },
  {
    name: 'Aggression',
    description:
      'Two or more people making physical contact such as shoving, hitting, grabbing, or wrestling, or a person displaying clearly threatening physical actions toward another. Raised voices or animated gestures without contact do NOT qualify. Describe the people involved, the location, and the nature of the confrontation.'
  }
]

const DEFAULT_ALERT_CONDITION_NAMES = ['Intrusion']

export const DEFAULT_ALERT_CONDITION_TEMPLATES: AlertConditionTemplate[] =
  ALERT_CONDITION_TEMPLATES.filter((template) =>
    DEFAULT_ALERT_CONDITION_NAMES.includes(template.name)
  )
